import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=8b2e7f04"
import script from "./SubmitSuccess.vue?vue&type=script&lang=js"
export * from "./SubmitSuccess.vue?vue&type=script&lang=js"
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=8b2e7f04&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports